import Swiper, { Pagination, Navigation, Autoplay } from 'swiper'

const imageSliderInstances = [];
const imageSliderElements = document.querySelectorAll('.image-slider');

if (imageSliderElements.length) {
    for (let i = 0; i < imageSliderElements.length; i++) {
        imageSliderInstances[i] = {
            init: false,
            instance: null,
            element: imageSliderElements[i],
        };
    }
}

function imageSlidersInit() {
    if (imageSliderInstances.length === 0) {
        return
    }

    for (let i = 0; i < imageSliderElements.length; i++) {
        if (! imageSliderInstances[i].init) {
            imageSliderInstances[i].init = true;

            imageSliderInstances[i].instance = initializeContentSlider(imageSliderInstances[i].element, i % 2 === 0);
        }
    }
}
imageSlidersInit();
window.addEventListener('resize', imageSlidersInit);

function unwrapAcfInnerBlocks(slider) {
    const wrapper = slider.querySelector('.swiper-wrapper');
    if (!wrapper) {
        return;
    }

    const innerBlocks = wrapper.firstElementChild;
    if (!innerBlocks || !innerBlocks.classList.contains('acf-innerblocks-container')) {
        return;
    }

    while (innerBlocks.firstChild) {
        wrapper.appendChild(innerBlocks.firstChild);
    }

    innerBlocks.remove();
}

function initializeContentSlider(slider) {
    unwrapAcfInnerBlocks(slider);

    const slides = slider.querySelectorAll('.swiper-slide');
    const titlePagination = slider.querySelectorAll('.pagination-titles');

    return new Swiper(slider, {
        modules: [ Pagination, Navigation, Autoplay ],
        spaceBetween: 20,
        speed: 700,
        autoplay: {
            delay: 4000,
            disableOnInteraction: true,
        },
        pagination: {
            el: '.swiper-pagination, .swiper-pagination-custom',
            clickable: true,
            renderBullet: function(index, className) {
                if (0 === titlePagination.length) {
                    return '<span class="swiper-pagination-bullet"></span>';
                }

                const title = slides[index].getAttribute('data-title');
                return '<div class="' + className + '">' + title + '</div>';
            },
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            768: {
                slidesPerView: 1,
                slidesPerGroup: 1,
            },
            1024: {
                slidesPerView: 2,
                slidesPerGroup: 2,
            },
            1440: {
                slidesPerView: 3,
                slidesPerGroup: 3,
            },
        },
    });
}
